/**
 * Dependency-free MiniMax voice constants, shared by the client (/tts) and the
 * server (`@/utils/minimaxVoice`). Kept separate so importing them into a page
 * doesn't drag axios and the API client into the browser bundle.
 */

/** Default synthesis model for cloned voices — highest quality tier. */
export const MINIMAX_SPEECH_MODEL = 'speech-2.8-hd';

/**
 * `audio_voices.model` prefix marking a voice that must be synthesized by
 * MiniMax. The suffix is the MiniMax speech model to synthesize with.
 */
export const MINIMAX_VOICE_MODEL_PREFIX = 'minimax/';

export const buildMiniMaxVoiceModel = (
  speechModel: string = MINIMAX_SPEECH_MODEL,
): string => `${MINIMAX_VOICE_MODEL_PREFIX}${speechModel}`;

export const isMiniMaxVoiceModel = (model?: string | null): model is string =>
  typeof model === 'string' && model.startsWith(MINIMAX_VOICE_MODEL_PREFIX);

/** Speech model pinned to a cloned voice, defaulting when the suffix is absent. */
export const getMiniMaxSpeechModel = (model?: string | null): string => {
  if (!isMiniMaxVoiceModel(model)) return MINIMAX_SPEECH_MODEL;
  return model.slice(MINIMAX_VOICE_MODEL_PREFIX.length) || MINIMAX_SPEECH_MODEL;
};

/** Source audio limits MiniMax enforces on the cloning sample. */
export const MINIMAX_CLONE_MIN_SECONDS = 10;
export const MINIMAX_CLONE_MAX_SECONDS = 5 * 60;
export const MINIMAX_CLONE_MAX_BYTES = 20 * 1024 * 1024;

/** Max characters MiniMax accepts in one synchronous T2A request. */
export const MINIMAX_MAX_TTS_CHARACTERS = 10000;
